import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
export default CatalogObjectSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    modifiers: {
      embedded: 'always',
      serializedOnFragment: 'modifier_list_data'
    }
  }
});